<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="pageTitle"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    class="approve-dialog-box"
    width="500px"
  >
    <section v-loading="getDetailLoading">
      <qx-card title="审核信息">
        <qx-detail-box :data="detailData.oilMasterCardBase" />
      </qx-card>
      <qx-card title="审核结果">
        <qx-custom-form
          class="approve-dialog-result"
          :noSubBtn="true"
          ref="baseForm"
          :formData="baseForm"
        />
      </qx-card>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  approve,
} from 'api';
export default {
  components: {
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      pageTitle: '',

      baseForm: {
        form: [
          {
            label: '审核结果',
            value: 'chooseResult',
            type: 'radio',
            default: 1,
            options: [
              {
                label: '通过',
                value: 1,
              },
              {
                label: '不通过',
                value: 2,
              },
            ],
          },
          {
            label: '审核意见',
            value: 'desc',
            type: 'input',
            width: '320px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          chooseResult: [ // 审核结果
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ],
        },
      },

      detailData: {
        oilMasterCardBase: {
          label: '',
          tableData: {
            // 主卡基本信息
            title: [
              { prop: 'etcCardNum', label: 'ETC卡号', span: 1 },
              { prop: 'etcCardTypeName', label: '卡类型', span: 1 },
              { prop: 'plateNumber', label: '车牌号', span: 1 },
              { prop: 'serviceName', label: '服务商', span: 1 },
              { prop: 'rechargeAmount', label: '充值金额', span: 1 },
              { prop: 'etcBalance', label: '充值前余额', span: 1 },
              { prop: 'applyUserName', label: '申请人', span: 1 },
              { prop: 'applyTime', label: '申请时间', span: 1 },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.baseForm && this.$refs.baseForm.reset();
      this.originData = item;
      this.pageTitle = 'ETC卡充值审核';
      this.detailData.oilMasterCardBase.tableData.data = this.originData;
    },

    hide () {
      this.dialogFormVisible = false;
    },

    async customFormPost () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        this.subLoading = true;
        const res = await approve({
          ...formData,
          busiId: this.originData.id,
          busiCode: '22000054',
        });
        this.subLoading = false;
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.hide();
          this.$emit('success');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.approve-dialog-box {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding-top: 0;
      .card {
        margin-bottom: 0;
        padding-bottom: 0;
        section {
          &:last-child {
            margin-bottom: 0 !important;
            padding-bottom: 0 !important;
          }
        }
        &:last-child {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
